import React from 'react';
import { Box, Button, Collapse, Stack, Typography } from '@mui/material';

import { CountedProductFilter, CountedProductFilters } from 'generated/graphql';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useServerTranslation } from 'hooks/useServerTranslation';
import { colors } from 'styles/theme/colors';
import ProductFilter from './ProductFilter';

type Props = {
    title: keyof Omit<CountedProductFilters, '__typename'>;
    filters: Omit<CountedProductFilter, '__typename'>[];
};

export default function FilterCategory({ filters, title }: Props) {
    const { t } = useServerTranslation();

    const [showFilters, toggleShowFilters] = React.useState(false);

    if (filters.length === 0) {
        return null;
    }

    return (
        <Box
            sx={{
                paddingBottom: 1,
                marginBottom: 1,
            }}
        >
            <Button
                disableRipple
                variant="black"
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: 0,
                    '&:hover': { backgroundColor: 'transparent', color: colors.pink2 },
                }}
                onClick={() => toggleShowFilters((show) => !show)}
                fullWidth
            >
                <Typography
                    variant="body2"
                    sx={{ fontSize: '14px', fontWeight: 300, marginBottom: 0.25 }}
                >
                    {t(`product-filter.${title}`)}
                </Typography>
                {showFilters ? <KeyboardArrowUpIcon sx={{ fontSize: '1rem' }} /> : <KeyboardArrowDownIcon sx={{ fontSize: '1rem' }} />}
            </Button>
            <Collapse in={showFilters}>
                <Stack sx={{ rowGap: 1.5, marginTop: 1.75, marginBottom: 0.75 }}>
                    {filters.map((filter) => (
                        <ProductFilter key={filter.name} title={title} filter={filter} />
                    ))}
                </Stack>
            </Collapse>
        </Box>
    );
}
